module.exports = __webpack_public_path__ + "img/hero-s-2.1fe9e830.png";